import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { CommonModule, NgOptimizedImage } from "@angular/common";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  HttpClientModule,
  provideHttpClient,
} from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { KeycloakAngularModule, KeycloakService } from "keycloak-angular";
import { CookieInterceptor } from "./interceptors/cookie.interceptor";
import { ToastrModule } from "ngx-toastr";
import { ErrorInterceptor } from "./interceptors/error.interceptor";
import { environment } from "../environments/environment";
import { SharedModule } from "./shared/shared.module";
import { NgxsModule } from "@ngxs/store";
import { CtfState } from "./core/ctf/store/ctf.state";
import { NgxsReduxDevtoolsPluginModule } from "@ngxs/devtools-plugin";
import { RouterModule } from "@angular/router";
import { ActualiteState } from "./core/actualite/store/actualite.state";
import { HofState } from "./core/hall-of-fame/store/hof.state";
import { UserProfileState } from "./core/user-profile/store/user-profile.state";
import { KpiState } from "./core/user-profile/store/kpi.state";
import { SettingsState } from "./shared/store/settings.state";
import { CtfAdminState } from "./core/admin/store/ctf-admin.state";
import { AssetAdminState } from "./core/admin/store/asset-admin.state"; // Add this import
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { QtmComponentLibraryModule } from "@qtm/angular";
import {
  provideTranslateService,
  TranslateLoader,
  TranslateModule,
} from "@ngx-translate/core";
import {
  provideTranslateHttpLoader,
  TranslateHttpLoader,
} from "@ngx-translate/http-loader";
import { LanguageInterceptor } from "./interceptors/language.interceptor";
import { EnvironmentTranslateLoader } from "./loaders/environment-translate";
import { MarkdownModule } from "ngx-markdown";

export function initializeKeycloak(keycloak: KeycloakService) {
  return () =>
    keycloak.init({
      config: {
        url: environment.idp,
        realm: environment.realm,
        clientId: "cyberquest-client",
      },
      initOptions: {
        checkLoginIframe: false,
      },
    });
}

export function translateFactory(http: HttpClient) {
  return new EnvironmentTranslateLoader(http, environment.questInstance);
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    NgxsModule.forRoot([
      CtfState,
      ActualiteState,
      HofState,
      UserProfileState,
      KpiState,
      SettingsState,
      CtfAdminState,
      AssetAdminState,
    ]),
    NgxsReduxDevtoolsPluginModule.forRoot(),
    CommonModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NgOptimizedImage,
    ToastrModule.forRoot(),
    KeycloakAngularModule,
    SharedModule,
    RouterModule,
    QtmComponentLibraryModule,
    TranslateModule.forRoot({
      fallbackLang: "en",
    }),
    MarkdownModule.forRoot(),
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CookieInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LanguageInterceptor,
      multi: true,
    },
    provideAnimationsAsync(),
    provideHttpClient(),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: translateFactory,
        deps: [HttpClient],
      },
      fallbackLang: "en",
      lang: "fr",
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
